// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"228":"b6986b7d","231":"07e4dfb6","291":"fd78bfa6","440":"bbc2260c","453":"bb257cf5","839":"cea4d80b","913":"89c6376b","978":"bdd58f86"}[chunkId] + ".chunk.js";
};